import { render, staticRenderFns } from "./ObtainingPricing.vue?vue&type=template&id=73bbdcfe&scoped=true"
import script from "./ObtainingPricing.vue?vue&type=script&lang=js"
export * from "./ObtainingPricing.vue?vue&type=script&lang=js"
import style0 from "./ObtainingPricing.vue?vue&type=style&index=0&id=73bbdcfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bbdcfe",
  null
  
)

export default component.exports